const Report = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-package" */ '@/pages/base-info/order-properties/package/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-package" */ '@/pages/base-info/order-properties/package/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-package" */ '@/pages/base-info/order-properties/package/edit.vue'
  )

export default {
  path: 'package',
  meta: {
    label: 'package',
    auth: 'package'
  },
  component: {
    name: 'Package',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoOrderPropertiesPackage',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'BaseInfoCreateOrderPropertiesPackage',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'BaseInfoEditOrderPropertiesPackage',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
